import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import RequisitionsBuy from '@/views/requisitions/buy.vue'
import RequisitionsCancelled from '@/views/requisitions/cancel.vue'
import RequisitionsCancelledRequest from '@/views/requisitions/cancel_request.vue'
import RequisitionsIndex from '@/views/requisitions/index.vue'
import RequisitionsDetails from '@/views/requisitions/request-details.vue'
import RequisitionsSell from '@/views/requisitions/sell.vue'

const requisitionsRoutes: RouteRecordRaw[] = [
  {
    path: '/requisitions',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [
      { path: '', name: 'Requisitions', component: RequisitionsIndex },
      { path: 'buy', name: 'Requisitions-Buy', component: RequisitionsBuy },
      { path: 'sell', name: 'Requisitions-Sell', component: RequisitionsSell },
      {
        path: 'cancellation-requests',
        name: 'Requisitions-Cancellation-Requests',
        component: RequisitionsCancelledRequest,
      },
      { path: 'cancelled', name: 'Requisitions-Cancelled', component: RequisitionsCancelled },
      { path: ':id', name: 'Requisitions-Details', component: RequisitionsDetails, props: true },
    ],
  },
]

export default requisitionsRoutes
